import { useCallback } from 'react';
import { IconSortArrow } from '../../../icons';
import Button from '../../Button/Button';
import './SortTableHeader.styles.scss';

export default function SortableHeader({
    columnKey,
    children,
    orderBy,
    sortOrder,
    onSort,
    defaultOrder = 'asc'
}: Readonly<{
    columnKey: string;
    children: React.ReactNode;
    orderBy: string | undefined;
    sortOrder: string | undefined;
    onSort: ((columnKey: string, sortOrder: string) => void) | undefined;
    defaultOrder?: 'asc' | 'desc';
}>) {
    const isSorted = orderBy === columnKey;
    const isAsc = sortOrder === 'asc';

    const handleSort = useCallback(
        (columnKey: string) => {
            if (!onSort) return;

            if (orderBy === columnKey) {
                onSort(columnKey, sortOrder === 'asc' ? 'desc' : 'asc');
            } else {
                onSort(columnKey, defaultOrder);
            }
        },
        [orderBy, sortOrder, onSort, defaultOrder]
    );

    return (
        <Button className="Table__header-sortable" onClick={() => handleSort(columnKey)} unstyled>
            <div className="Table__header-arrows">
                {isSorted && <IconSortArrow className={`Table__header-arrow active ${isAsc ? 'asc' : 'desc'}`} />}
            </div>
            <span>{children}</span>
        </Button>
    );
}
